export default __webpack_public_path__ + "static/media/Walmart.803c9ee4.png";